<ng-container *ngFor="let item of transformItems; trackBy: trackByValue">
  <button
    mat-menu-item
    (click)="setTransform(item.transform)"
    [attr.data-test]="'area-options-menu-transform-' + item.transform"
  >
    <capra-icon
      class="menu-dot-indicator"
      [style.visibility]="item.transform === transform ? 'visible' : 'hidden'"
      icon="icon-dot-indicator"
    >
    </capra-icon>
    {{ item.label }}
  </button>
</ng-container>
<mat-divider></mat-divider>
<ng-container *ngFor="let interp of interpolationItems">
  <button
    mat-menu-item
    (click)="setInterpolation(interp.type)"
    attr.data-test="area-options-interpolation-{{ interp.type }}"
  >
    <capra-icon
      class="menu-dot-indicator"
      [style.visibility]="interp.type === interpolationType ? 'visible' : 'hidden'"
      icon="icon-dot-indicator"
    >
    </capra-icon>
    {{ interp.label }}
  </button>
</ng-container>
